export default __webpack_public_path__ + "static/media/ball 03 copy.09491699.png";